// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-light: #e5e7eb;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.user-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
}

.user-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
}

.user-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--border-light);
}
.user-header .user-header-data {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.client-actions {
  display: flex;
  gap: 0.75rem;
}
.client-actions button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}
.client-actions button.btn-update {
  background-color: var(--primary-light-bg);
  color: var(--primary-color);
}
.client-actions button.btn-update:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.client-actions button.btn-delete {
  background-color: var(--danger-light-bg);
  color: var(--danger-color);
}
.client-actions button.btn-delete:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  margin-right: 1.5rem;
}

.user-title h2 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.3rem;
  font-weight: 600;
}

.user-status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.5rem;
}
.user-status.active {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.user-status.inactive {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}

.user-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 0.8rem;
  margin-bottom: 2rem;
}

.view-user-detailspage--detail-item {
  display: flex;
  gap: 1rem;
}
.view-user-detailspage--detail-item .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
  flex-shrink: 0;
}
.view-user-detailspage--detail-item label {
  display: block;
  color: var(--text-light);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.view-user-detailspage--detail-item p {
  margin: 0;
  color: var(--text-dark);
  font-size: 0.95rem;
  font-weight: 500;
}

.role-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.case-assignments-section {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--border-light);
}
.case-assignments-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.case-assignments-section .section-header .section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.case-assignments-section .section-header .section-title .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
}
.case-assignments-section .section-header .section-title h3 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.1rem;
  font-weight: 600;
}
.case-assignments-section .section-header .add-case-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 8px 18px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
}
.case-assignments-section .section-header .add-case-btn:hover {
  background-color: #3c5ce6;
  transform: translateY(-1px);
}
.case-assignments-section .section-header .add-case-btn svg {
  font-size: 1rem;
}

.add-case-form {
  background-color: var(--bg-light);
  border: 1px solid var(--border-light);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}
.add-case-form .form-header {
  margin-bottom: 1rem;
}
.add-case-form .form-header h4 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1rem;
  font-weight: 600;
}
.add-case-form .form-content {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
}
.add-case-form .form-content .case-selector-dropdown {
  flex: 1 1;
  position: relative;
}
.add-case-form .form-content .case-selector-dropdown label {
  display: block;
  color: var(--text-medium);
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-wrapper {
  position: relative;
}
.add-case-form .form-content .case-selector-dropdown .search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.add-case-form .form-content .case-selector-dropdown .search-input-container .search-input {
  width: 100%;
  padding: 0.75rem 2.5rem 0.75rem 0.75rem;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  font-size: 0.875rem;
  background-color: white;
  transition: var(--transition);
}
.add-case-form .form-content .case-selector-dropdown .search-input-container .search-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);
}
.add-case-form .form-content .case-selector-dropdown .search-input-container .search-input::placeholder {
  color: var(--text-light);
}
.add-case-form .form-content .case-selector-dropdown .search-input-container .dropdown-arrow {
  position: absolute;
  right: 0.75rem;
  color: var(--text-light);
  pointer-events: none;
}
.add-case-form .form-content .case-selector-dropdown .case-selector {
  position: relative;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .custom-dropdown-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .custom-dropdown-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.add-case-form .form-content .case-selector-dropdown .case-selector .custom-dropdown-input:hover:not(:focus) {
  border-color: #9ca3af;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .custom-dropdown-input::placeholder {
  color: #9ca3af;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-tabs button:hover {
  background: #f3f4f6;
  color: #374151;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-tabs button.active {
  background: #ffffff;
  color: #3b82f6;
  font-weight: 600;
  border-bottom-color: #3b82f6;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option:hover {
  background: #f9fafb;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option.selected .case-parties {
  font-weight: 600;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  margin-bottom: 0.25rem;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .no-data {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 400px;
  overflow: hidden;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header {
  border-bottom: 1px solid var(--border-light);
  padding: 0;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs {
  display: flex;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn {
  flex: 1 1;
  padding: 0.75rem;
  border: none;
  background-color: var(--bg-light);
  color: var(--text-medium);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn:first-child {
  border-top-left-radius: 8px;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn:last-child {
  border-top-right-radius: 8px;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn.active {
  background-color: var(--primary-color);
  color: white;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn:hover:not(.active) {
  background-color: #e5e7eb;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content {
  max-height: 320px;
  overflow-y: auto;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .loading-state,
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .empty-state,
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .no-results {
  padding: 2rem;
  text-align: center;
  color: var(--text-light);
  font-size: 0.875rem;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option {
  padding: 0.75rem;
  border-bottom: 1px solid var(--border-light);
  cursor: pointer;
  transition: var(--transition);
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option:hover {
  background-color: var(--bg-light);
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option:last-child {
  border-bottom: none;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option .case-details .case-parties {
  font-weight: 500;
  color: var(--text-dark);
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option .case-details .case-ref {
  color: var(--primary-color);
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option .case-details .case-number {
  color: var(--text-light);
  font-size: 0.75rem;
}
.add-case-form .form-content .form-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-shrink: 0;
}
.add-case-form .form-content .form-actions .save-btn,
.add-case-form .form-content .form-actions .cancel-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  border: none;
  white-space: nowrap;
}
.add-case-form .form-content .form-actions .save-btn {
  background-color: var(--success-color);
  color: white;
}
.add-case-form .form-content .form-actions .save-btn:hover:not(:disabled) {
  background-color: #059669;
}
.add-case-form .form-content .form-actions .save-btn:disabled {
  background-color: var(--text-light);
  cursor: not-allowed;
}
.add-case-form .form-content .form-actions .cancel-btn {
  background-color: transparent;
  color: var(--text-medium);
  border: 1px solid var(--border-light);
}
.add-case-form .form-content .form-actions .cancel-btn:hover {
  background-color: var(--bg-light);
}

.case-assignments-list .loading-state,
.case-assignments-list .empty-state {
  padding: 3rem 2rem;
  text-align: center;
  color: var(--text-light);
  font-size: 0.875rem;
  background-color: var(--bg-light);
  border-radius: var(--border-radius);
  border: 1px solid var(--border-light);
}
.case-assignments-list .assignments-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
}
.case-assignments-list .assignments-grid .assignment-card {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background-color: white;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  transition: var(--transition);
}
.case-assignments-list .assignments-grid .assignment-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.case-assignments-list .assignments-grid .assignment-card .assignment-info {
  flex: 1 1;
}
.case-assignments-list .assignments-grid .assignment-card .assignment-info .court-ref {
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 0.25rem;
  font-size: 0.95rem;
}
.case-assignments-list .assignments-grid .assignment-card .assignment-info .parties-info {
  color: var(--text-medium);
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
  line-height: 1.3;
}
.case-assignments-list .assignments-grid .assignment-card .assignment-info .source-info {
  color: var(--warning-color);
  font-size: 0.75rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
  text-transform: capitalize;
}
.case-assignments-list .assignments-grid .assignment-card .assignment-info .assignment-meta .created-date {
  color: var(--text-light);
  font-size: 0.75rem;
}
.case-assignments-list .assignments-grid .assignment-card .delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: transparent;
  color: var(--danger-color);
  border: 1px solid var(--danger-color);
  border-radius: 6px;
  cursor: pointer;
  transition: var(--transition);
}
.case-assignments-list .assignments-grid .assignment-card .delete-btn:hover:not(:disabled) {
  background-color: var(--danger-color);
  color: white;
}
.case-assignments-list .assignments-grid .assignment-card .delete-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.case-assignments-list .assignments-grid .assignment-card .delete-btn svg {
  font-size: 0.875rem;
}
.case-assignments-list .assignments-grid .assignment-card .delete-btn .mini-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(239, 68, 68, 0.2);
  border-top-color: var(--danger-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.error-message {
  color: var(--danger-color);
  font-size: 1rem;
  padding: 2rem;
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .user-detail-container {
    padding: 1rem;
  }
  .user-card {
    padding: 1.5rem;
  }
  .user-details-grid {
    grid-template-columns: 1fr;
  }
  .case-assignments-section .section-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .case-assignments-section .section-header .add-case-btn {
    justify-content: center;
  }
  .assignments-grid {
    grid-template-columns: 1fr;
  }
  .add-case-form {
    padding: 1rem;
  }
  .add-case-form .form-content {
    flex-direction: column;
    align-items: stretch;
  }
  .add-case-form .form-content .form-actions {
    justify-content: flex-start;
  }
  .add-case-form .form-content .form-actions .save-btn,
  .add-case-form .form-content .form-actions .cancel-btn {
    flex: none;
  }
  .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn {
    padding: 0.5rem;
    font-size: 0.8rem;
  }
}
@media (max-width: 480px) {
  .user-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  .user-header .avatar {
    margin-right: 0;
  }
  .view-user-detailspage--detail-item .icon {
    margin-top: 0;
  }
  .assignment-card {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .assignment-card .delete-btn {
    align-self: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/UserDetailsPage/UserDetailsPage.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AACF;;AAGA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,4CAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAAJ;;AAIE;EACA,aAAA;EACA,YAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AADJ;AAGI;EACE,yCAAA;EACA,2BAAA;AADN;AAGM;EACE,YAAA;EACA,2BAAA;AADR;AAKI;EACE,wCAAA;EACA,0BAAA;AAHN;AAKM;EACE,YAAA;EACA,2BAAA;AAHR;;AASA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AANF;;AAUE;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AARF;AAUE;EACE,yCAAA;EACA,2BAAA;AARJ;AAWE;EACE,wCAAA;EACA,0BAAA;AATJ;;AAaA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EAEA,SAAA;AAXF;AAcE;EACE,2BAAA;EACA,kBAAA;EAEA,cAAA;AAbJ;AAgBE;EACE,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAdJ;AAiBE;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAfJ;;AAmBA;EACE,qBAAA;EACA,wBAAA;EACA,sCAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAhBF;;AAoBA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AAjBF;AAmBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAjBN;AAmBM;EACE,2BAAA;EACA,kBAAA;AAjBR;AAoBM;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAlBR;AAsBI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AApBN;AAsBM;EACE,yBAAA;EACA,2BAAA;AApBR;AAuBM;EACE,eAAA;AArBR;;AA2BA;EACE,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,eAAA;EACA,qBAAA;AAxBF;AA0BE;EACE,mBAAA;AAxBJ;AA0BI;EACE,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAxBN;AA6BE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AA3BJ;AA6BI;EACE,SAAA;EACA,kBAAA;AA3BN;AA6BM;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AA3BR;AA8BM;EACE,kBAAA;AA5BR;AA+BM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA7BR;AA+BQ;EACE,WAAA;EACA,uCAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AA7BV;AA+BU;EACE,aAAA;EACA,kCAAA;EACA,4CAAA;AA7BZ;AAgCU;EACE,wBAAA;AA9BZ;AAkCQ;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EACA,oBAAA;AAhCV;AAqCM;EACE,kBAAA;AAnCR;AAqCQ;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAnCV;AAqCU;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAnCZ;AAsCU;EACE,qBAAA;AApCZ;AAuCU;EACE,cAAA;AArCZ;AAyCQ;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EAEA,mBAAA;EACA,gBAAA;EACA,yCAAA;AAxCV;AA0CU;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AAxCZ;AA0CY;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AAxCd;AA0Cc;EACE,mBAAA;EACA,cAAA;AAxChB;AA2Cc;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AAzChB;AA8CU;EACE,iBAAA;EACA,gBAAA;AA5CZ;AA8CY;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AA5Cd;AA8Cc;EACE,mBAAA;AA5ChB;AA+Cc;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AA7ChB;AA+CgB;EACE,gBAAA;AA7ClB;AAkDgB;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAhDlB;AAmDgB;EACE,kBAAA;EACA,cAAA;EACA,mGAAA;EAEA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AAlDlB;AAqDgB;EACE,kBAAA;EACA,cAAA;AAnDlB;AAwDY;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAtDd;AA4DM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AA1DR;AA4DQ;EACE,4CAAA;EACA,UAAA;AA1DV;AA4DU;EACE,aAAA;AA1DZ;AA4DY;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,iCAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AA1Dd;AA4Dc;EACE,2BAAA;AA1DhB;AA6Dc;EACE,4BAAA;AA3DhB;AA8Dc;EACE,sCAAA;EACA,YAAA;AA5DhB;AA+Dc;EACE,yBAAA;AA7DhB;AAmEQ;EACE,iBAAA;EACA,gBAAA;AAjEV;AAmEU;;;EAGE,aAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;AAjEZ;AAqEY;EACE,gBAAA;EACA,4CAAA;EACA,eAAA;EACA,6BAAA;AAnEd;AAqEc;EACE,iCAAA;AAnEhB;AAsEc;EACE,mBAAA;AApEhB;AAwEgB;EACE,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAtElB;AAyEgB;EACE,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAvElB;AA0EgB;EACE,wBAAA;EACA,kBAAA;AAxElB;AAiFI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AA/EN;AAiFM;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;AA/ER;AAkFM;EACE,sCAAA;EACA,YAAA;AAhFR;AAkFQ;EACE,yBAAA;AAhFV;AAmFQ;EACE,mCAAA;EACA,mBAAA;AAjFV;AAqFM;EACE,6BAAA;EACA,yBAAA;EACA,qCAAA;AAnFR;AAqFQ;EACE,iCAAA;AAnFV;;AA6FE;;EAEE,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,iCAAA;EACA,mCAAA;EACA,qCAAA;AA1FJ;AA6FE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AA3FJ;AA6FI;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;AA3FN;AA6FM;EACE,yCAAA;AA3FR;AA+FM;EACE,SAAA;AA7FR;AA+FQ;EACE,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AA7FV;AAgGQ;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AA9FV;AAiGQ;EACE,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;AA/FV;AAmGU;EACE,wBAAA;EACA,kBAAA;AAjGZ;AAsGM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AApGR;AAsGQ;EACE,qCAAA;EACA,YAAA;AApGV;AAuGQ;EACE,YAAA;EACA,mBAAA;AArGV;AAwGQ;EACE,mBAAA;AAtGV;AAyGQ;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,qCAAA;EACA,kBAAA;EACA,kCAAA;AAvGV;;AA8GA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;AA3GF;;AA8GA;EACE,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AA3GF;;AA+GA;EACE;IACE,yBAAA;EA5GF;AACF;AA+GA;EACE;IACE,UAAA;IACA,2BAAA;EA7GF;EAgHA;IACE,UAAA;IACA,wBAAA;EA9GF;AACF;AAkHA;EACE,UAAA;AAhHF;;AAmHA;EACE,mBAAA;EACA,kBAAA;AAhHF;;AAmHA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AAhHF;;AAmHA;EACE,mBAAA;AAhHF;;AAoHA;EACE;IACE,aAAA;EAjHF;EAoHA;IACE,eAAA;EAlHF;EAqHA;IACE,0BAAA;EAnHF;EAuHE;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EArHJ;EAuHI;IACE,uBAAA;EArHN;EA0HA;IACE,0BAAA;EAxHF;EA2HA;IACE,aAAA;EAzHF;EA2HE;IACE,sBAAA;IACA,oBAAA;EAzHJ;EA2HI;IACE,2BAAA;EAzHN;EA2HM;;IAEE,UAAA;EAzHR;EAmIQ;IACE,eAAA;IACA,iBAAA;EAjIV;AACF;AAwIA;EACE;IACE,sBAAA;IACA,kBAAA;IACA,SAAA;EAtIF;EAwIE;IACE,eAAA;EAtIJ;EA2IE;IACE,aAAA;EAzIJ;EA6IA;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EA3IF;EA6IE;IACE,kBAAA;EA3IJ;AACF","sourcesContent":[":root {\r\n  --primary-light: #eef2ff;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --warning-color: #f59e0b;\r\n  --text-dark: #1f2937;\r\n  --text-medium: #4b5563;\r\n  --text-light: #9ca3af;\r\n  --bg-light: #f9fafb;\r\n  --card-bg: #ffffff;\r\n  --border-light: #e5e7eb;\r\n  --border-radius: 12px;\r\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n  --transition: all 0.3s ease;\r\n}\r\n\r\n.user-detail-container {\r\n  padding: 1rem;\r\n  background-color:#f4f6f8;\r\n  display: flex;\r\n  // min-height: 100vh;\r\n}\r\n\r\n.user-card {\r\n  background-color: var(--card-bg);\r\n  border-radius: var(--border-radius-primary);\r\n  box-shadow: var(--box-shadow);\r\n  width: 100%;\r\n  padding: 2rem;\r\n}\r\n\r\n.user-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1.5rem;\r\n  border-bottom: 1px solid var(--border-light);\r\n\r\n  .user-header-data {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1.5rem;\r\n  }\r\n}\r\n\r\n  .client-actions {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  \r\n  button {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n    \r\n    &.btn-update {\r\n      background-color: var(--primary-light-bg);\r\n      color: var(--primary-color);\r\n      \r\n      &:hover {\r\n        opacity: 0.9;\r\n        transform: translateY(-1px);\r\n      }\r\n    }\r\n    \r\n    &.btn-delete {\r\n      background-color: var(--danger-light-bg);\r\n      color: var(--danger-color);\r\n      \r\n      &:hover {\r\n        opacity: 0.9;\r\n        transform: translateY(-1px);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.avatar {\r\n  width: 64px;\r\n  height: 64px;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.75rem;\r\n  font-weight: bold;\r\n  margin-right: 1.5rem;\r\n}\r\n\r\n.user-title {\r\n  h2 {\r\n    margin: 0;\r\n    color: var(--text-dark);\r\n    font-size: 1.3rem;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.user-status {\r\n  display: inline-block;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  margin-top: 0.5rem;\r\n\r\n  &.active {\r\n    background-color: rgba(16, 185, 129, 0.1);\r\n    color: var(--success-color);\r\n  }\r\n\r\n  &.inactive {\r\n    background-color: rgba(239, 68, 68, 0.1);\r\n    color: var(--danger-color);\r\n  }\r\n}\r\n\r\n.user-details-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 0.8rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.view-user-detailspage--detail-item {\r\n  display: flex;\r\n  //align-items: flex-start;\r\n  gap: 1rem;\r\n  // align-items: center !important;\r\n\r\n  .icon {\r\n    color: var(--primary-color);\r\n    font-size: 1.25rem;\r\n    // margin-top: 0.25rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  label {\r\n    display: block;\r\n    color: var(--text-light);\r\n    font-size: 0.75rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    color: var(--text-dark);\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.role-badge {\r\n  display: inline-block;\r\n  padding: 0.25rem 0.75rem;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  border-radius: 20px;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n}\r\n\r\n// Case Assignments Section\r\n.case-assignments-section {\r\n  margin-top: 2rem;\r\n  padding-top: 2rem;\r\n  border-top: 1px solid var(--border-light);\r\n\r\n  .section-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 1.5rem;\r\n\r\n    .section-title {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.75rem;\r\n\r\n      .icon {\r\n        color: var(--primary-color);\r\n        font-size: 1.25rem;\r\n      }\r\n\r\n      h3 {\r\n        margin: 0;\r\n        color: var(--text-dark);\r\n        font-size: 1.1rem;\r\n        font-weight: 600;\r\n      }\r\n    }\r\n\r\n    .add-case-btn {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n      padding : 8px 18px;\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n      border: none;\r\n      border-radius: 8px;\r\n      font-size: 0.9rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      transition: var(--transition);\r\n\r\n      &:hover {\r\n        background-color: #3c5ce6;\r\n        transform: translateY(-1px);\r\n      }\r\n\r\n      svg {\r\n        font-size: 1rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.add-case-form {\r\n  background-color: var(--bg-light);\r\n  border: 1px solid var(--border-light);\r\n  border-radius: var(--border-radius);\r\n  padding: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n\r\n  .form-header {\r\n    margin-bottom: 1rem;\r\n\r\n    h4 {\r\n      margin: 0;\r\n      color: var(--text-dark);\r\n      font-size: 1rem;\r\n      font-weight: 600;\r\n    }\r\n  }\r\n\r\n  // Updated layout for input and actions in same row\r\n  .form-content {\r\n    display: flex;\r\n    gap: 1rem;\r\n    align-items: flex-end;\r\n\r\n    .case-selector-dropdown {\r\n      flex: 1;\r\n      position: relative;\r\n\r\n      label {\r\n        display: block;\r\n        color: var(--text-medium);\r\n        font-size: 0.875rem;\r\n        font-weight: 500;\r\n        margin-bottom: 0.5rem;\r\n      }\r\n\r\n      .dropdown-wrapper {\r\n        position: relative;\r\n      }\r\n\r\n      .search-input-container {\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        .search-input {\r\n          width: 100%;\r\n          padding: 0.75rem 2.5rem 0.75rem 0.75rem;\r\n          border: 1px solid var(--border-light);\r\n          border-radius: 8px;\r\n          font-size: 0.875rem;\r\n          background-color: white;\r\n          transition: var(--transition);\r\n\r\n          &:focus {\r\n            outline: none;\r\n            border-color: var(--primary-color);\r\n            box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);\r\n          }\r\n\r\n          &::placeholder {\r\n            color: var(--text-light);\r\n          }\r\n        }\r\n\r\n        .dropdown-arrow {\r\n          position: absolute;\r\n          right: 0.75rem;\r\n          color: var(--text-light);\r\n          pointer-events: none;\r\n        }\r\n      }\r\n\r\n      // Case Selector Dropdown - Updated to match ExpenseForm exactly\r\n      .case-selector {\r\n        position: relative;\r\n\r\n        .custom-dropdown-input {\r\n          width: 100%;\r\n          padding: 0.5rem;\r\n          border: 1px solid #d1d5db;\r\n          border-radius: 0.25rem;\r\n          font-size: 0.875rem;\r\n          font-family: inherit;\r\n          color: #374151;\r\n          background: #ffffff;\r\n          box-sizing: border-box;\r\n          height: 2.5rem;\r\n\r\n          &:focus {\r\n            outline: none;\r\n            border-color: #3b82f6;\r\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n          }\r\n\r\n          &:hover:not(:focus) {\r\n            border-color: #9ca3af;\r\n          }\r\n\r\n          &::placeholder {\r\n            color: #9ca3af;\r\n          }\r\n        }\r\n\r\n        .dropdown-content {\r\n          position: absolute;\r\n          top: 100%;\r\n          left: 0;\r\n          width: 100%;\r\n          background: #ffffff;\r\n          border: 1px solid #d1d5db;\r\n          border-radius: 0.375rem;\r\n          z-index: 1000;\r\n          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\r\n            0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n          margin-top: 0.25rem;\r\n          overflow: hidden;\r\n          animation: dropdown-fade-in 0.2s ease-out;\r\n\r\n          .dropdown-tabs {\r\n            display: flex;\r\n            background: #f9fafb;\r\n            border-bottom: 1px solid #e5e7eb;\r\n\r\n            button {\r\n              flex: 1;\r\n              padding: 0.75rem 1rem;\r\n              border: none;\r\n              background: transparent;\r\n              color: #6b7280;\r\n              font-weight: 500;\r\n              font-size: 0.875rem;\r\n              cursor: pointer;\r\n              transition: all 0.2s ease;\r\n              border-bottom: 2px solid transparent;\r\n\r\n              &:hover {\r\n                background: #f3f4f6;\r\n                color: #374151;\r\n              }\r\n\r\n              &.active {\r\n                background: #ffffff;\r\n                color: #3b82f6;\r\n                font-weight: 600;\r\n                border-bottom-color: #3b82f6;\r\n              }\r\n            }\r\n          }\r\n\r\n          .dropdown-options {\r\n            max-height: 250px;\r\n            overflow-y: auto;\r\n\r\n            .dropdown-option {\r\n              padding: 0.75rem 1rem;\r\n              cursor: pointer;\r\n              border-bottom: 1px solid #f3f4f6;\r\n              transition: all 0.2s ease;\r\n\r\n              &:hover {\r\n                background: #f9fafb;\r\n              }\r\n\r\n              &.selected {\r\n                background: #eff6ff;\r\n                color: #1e40af;\r\n                border-left: 3px solid #3b82f6;\r\n\r\n                .case-parties {\r\n                  font-weight: 600;\r\n                }\r\n              }\r\n\r\n              .case-info {\r\n                .case-parties {\r\n                  font-weight: 500;\r\n                  color: #374151;\r\n                  font-size: 0.875rem;\r\n                  margin-bottom: 0.25rem;\r\n                  line-height: 1.4;\r\n                }\r\n\r\n                .case-ref {\r\n                  font-size: 0.75rem;\r\n                  color: #6b7280;\r\n                  font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas,\r\n                    \"Liberation Mono\", Menlo, monospace;\r\n                  background: #f3f4f6;\r\n                  padding: 0.125rem 0.375rem;\r\n                  border-radius: 0.25rem;\r\n                  display: inline-block;\r\n                  margin-bottom: 0.25rem;\r\n                }\r\n\r\n                .case-number {\r\n                  font-size: 0.75rem;\r\n                  color: #9ca3af;\r\n                }\r\n              }\r\n            }\r\n\r\n            .no-data {\r\n              padding: 2rem 1rem;\r\n              text-align: center;\r\n              color: #6b7280;\r\n              font-style: italic;\r\n              font-size: 0.875rem;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .dropdown-menu {\r\n        position: absolute;\r\n        top: 100%;\r\n        left: 0;\r\n        right: 0;\r\n        background-color: white;\r\n        border: 1px solid var(--border-light);\r\n        border-radius: 8px;\r\n        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\r\n        z-index: 1000;\r\n        max-height: 400px;\r\n        overflow: hidden;\r\n\r\n        .dropdown-header {\r\n          border-bottom: 1px solid var(--border-light);\r\n          padding: 0;\r\n\r\n          .court-tabs {\r\n            display: flex;\r\n\r\n            .tab-btn {\r\n              flex: 1;\r\n              padding: 0.75rem;\r\n              border: none;\r\n              background-color: var(--bg-light);\r\n              color: var(--text-medium);\r\n              font-size: 0.875rem;\r\n              font-weight: 500;\r\n              cursor: pointer;\r\n              transition: var(--transition);\r\n\r\n              &:first-child {\r\n                border-top-left-radius: 8px;\r\n              }\r\n\r\n              &:last-child {\r\n                border-top-right-radius: 8px;\r\n              }\r\n\r\n              &.active {\r\n                background-color: var(--primary-color);\r\n                color: white;\r\n              }\r\n\r\n              &:hover:not(.active) {\r\n                background-color: #e5e7eb;\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        .dropdown-content {\r\n          max-height: 320px;\r\n          overflow-y: auto;\r\n\r\n          .loading-state,\r\n          .empty-state,\r\n          .no-results {\r\n            padding: 2rem;\r\n            text-align: center;\r\n            color: var(--text-light);\r\n            font-size: 0.875rem;\r\n          }\r\n\r\n          .cases-list {\r\n            .case-option {\r\n              padding: 0.75rem;\r\n              border-bottom: 1px solid var(--border-light);\r\n              cursor: pointer;\r\n              transition: var(--transition);\r\n\r\n              &:hover {\r\n                background-color: var(--bg-light);\r\n              }\r\n\r\n              &:last-child {\r\n                border-bottom: none;\r\n              }\r\n\r\n              .case-details {\r\n                .case-parties {\r\n                  font-weight: 500;\r\n                  color: var(--text-dark);\r\n                  margin-bottom: 0.25rem;\r\n                  font-size: 0.875rem;\r\n                }\r\n\r\n                .case-ref {\r\n                  color: var(--primary-color);\r\n                  font-size: 0.8rem;\r\n                  font-weight: 500;\r\n                  margin-bottom: 0.25rem;\r\n                }\r\n\r\n                .case-number {\r\n                  color: var(--text-light);\r\n                  font-size: 0.75rem;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .form-actions {\r\n      display: flex;\r\n      gap: 0.75rem;\r\n      align-items: center;\r\n      flex-shrink: 0; // Prevent shrinking\r\n\r\n      .save-btn,\r\n      .cancel-btn {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.5rem;\r\n        padding: 0.75rem 1rem; // Match input height\r\n        border-radius: 6px;\r\n        font-size: 0.875rem;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: var(--transition);\r\n        border: none;\r\n        white-space: nowrap; // Prevent text wrapping\r\n      }\r\n\r\n      .save-btn {\r\n        background-color: var(--success-color);\r\n        color: white;\r\n\r\n        &:hover:not(:disabled) {\r\n          background-color: #059669;\r\n        }\r\n\r\n        &:disabled {\r\n          background-color: var(--text-light);\r\n          cursor: not-allowed;\r\n        }\r\n      }\r\n\r\n      .cancel-btn {\r\n        background-color: transparent;\r\n        color: var(--text-medium);\r\n        border: 1px solid var(--border-light);\r\n\r\n        &:hover {\r\n          background-color: var(--bg-light);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.case-assignments-list {\r\n\r\n  .loading-state,\r\n  .empty-state {\r\n    padding: 3rem 2rem;\r\n    text-align: center;\r\n    color: var(--text-light);\r\n    font-size: 0.875rem;\r\n    background-color: var(--bg-light);\r\n    border-radius: var(--border-radius);\r\n    border: 1px solid var(--border-light);\r\n  }\r\n\r\n  .assignments-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    gap: 1rem;\r\n\r\n    .assignment-card {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      padding: 1rem;\r\n      background-color: white;\r\n      border: 1px solid var(--border-light);\r\n      border-radius: 8px;\r\n      transition: var(--transition);\r\n\r\n      &:hover {\r\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n        // border-color: var(--primary-color);\r\n      }\r\n\r\n      .assignment-info {\r\n        flex: 1;\r\n\r\n        .court-ref {\r\n          font-weight: 600;\r\n          color: var(--text-dark);\r\n          margin-bottom: 0.25rem;\r\n          font-size: 0.95rem;\r\n        }\r\n\r\n        .parties-info {\r\n          color: var(--text-medium);\r\n          font-size: 0.85rem;\r\n          margin-bottom: 0.25rem;\r\n          line-height: 1.3;\r\n        }\r\n\r\n        .source-info {\r\n          color: var(--warning-color);\r\n          font-size: 0.75rem;\r\n          font-weight: 500;\r\n          margin-bottom: 0.25rem;\r\n          text-transform: capitalize;\r\n        }\r\n\r\n        .assignment-meta {\r\n          .created-date {\r\n            color: var(--text-light);\r\n            font-size: 0.75rem;\r\n          }\r\n        }\r\n      }\r\n\r\n      .delete-btn {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        width: 32px;\r\n        height: 32px;\r\n        background-color: transparent;\r\n        color: var(--danger-color);\r\n        border: 1px solid var(--danger-color);\r\n        border-radius: 6px;\r\n        cursor: pointer;\r\n        transition: var(--transition);\r\n\r\n        &:hover:not(:disabled) {\r\n          background-color: var(--danger-color);\r\n          color: white;\r\n        }\r\n\r\n        &:disabled {\r\n          opacity: 0.6;\r\n          cursor: not-allowed;\r\n        }\r\n\r\n        svg {\r\n          font-size: 0.875rem;\r\n        }\r\n\r\n        .mini-spinner {\r\n          width: 16px;\r\n          height: 16px;\r\n          border: 2px solid rgba(239, 68, 68, 0.2);\r\n          border-top-color: var(--danger-color);\r\n          border-radius: 50%;\r\n          animation: spin 1s linear infinite;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid rgba(67, 97, 238, 0.2);\r\n  border-top-color: var(--primary-color);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin: 0 auto;\r\n}\r\n\r\n.error-message {\r\n  color: var(--danger-color);\r\n  font-size: 1rem;\r\n  padding: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n// Animations\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes dropdown-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// Scrollbar styling for dropdown - matching ExpenseForm\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {\r\n  background: #f1f5f9;\r\n  border-radius: 3px;\r\n}\r\n\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {\r\n  background: #cbd5e1;\r\n  border-radius: 3px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {\r\n  background: #94a3b8;\r\n}\r\n\r\n// Responsive Design\r\n@media (max-width: 768px) {\r\n  .user-detail-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .user-card {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .user-details-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .case-assignments-section {\r\n    .section-header {\r\n      flex-direction: column;\r\n      gap: 1rem;\r\n      align-items: stretch;\r\n\r\n      .add-case-btn {\r\n        justify-content: center;\r\n      }\r\n    }\r\n  }\r\n\r\n  .assignments-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .add-case-form {\r\n    padding: 1rem;\r\n\r\n    .form-content {\r\n      flex-direction: column;\r\n      align-items: stretch;\r\n\r\n      .form-actions {\r\n        justify-content: flex-start;\r\n\r\n        .save-btn,\r\n        .cancel-btn {\r\n          flex: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .case-selector-dropdown {\r\n    .dropdown-menu {\r\n      .dropdown-header {\r\n        .court-tabs {\r\n          .tab-btn {\r\n            padding: 0.5rem;\r\n            font-size: 0.8rem;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .user-header {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    gap: 1rem;\r\n\r\n    .avatar {\r\n      margin-right: 0;\r\n    }\r\n  }\r\n\r\n  .view-user-detailspage--detail-item {\r\n    .icon {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n\r\n  .assignment-card {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    align-items: stretch;\r\n\r\n    .delete-btn {\r\n      align-self: center;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
